export default __webpack_public_path__ + "static/dragonfly@2x-f803fef4292e8deebcadfa57a57e246f.png";